var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos"},[_c('div',{staticClass:"wrapper"},[_c('videos',{attrs:{"hideHeaders":_vm.hideHeaders,"video-data":_vm.video,"ajax-more":true,"limit":20}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }